import { Box, Flex, Image, Text } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getBanners, getInnerBanners } from "../../Redux/App/action";
import { Link } from "react-router-dom";
const TopSlider = () => {
  const dispatch = useDispatch();
  const { internalBanner } = useSelector((store) => store.appReducer);
  const sortedBanner = internalBanner
    .slice()
    .sort((a, b) => a.sequence - b.sequence);
  useEffect(() => {
    dispatch(getInnerBanners);
  }, [dispatch]);
  const [currentSlide, setCurrentSlide] = useState(0);
  const slidesCount = sortedBanner.length;

  const getCategoryRoute = (categoryName) => {
    switch (categoryName) {
      case "GREETINGS-BANNER":
        return "/GreetingsSubCat";
      case "INVITATIONS-BANNER":
        return "/InvitationSubCat";
      case "PLANTS-BANNERS":
        return "/plantEcommerce";
      case "CAKES-BANNERS":
        return "/cakesandchochlate";
      case "PHOTOFRAMES-BANNERS":
        return "/photoFrames";
      case "POTS-BANNERS":
        return "/potsAll";
      case "BANQUETHALLS-BANNERS":
        return "/banquet";
      case "HOMEDECOR-BANNERS":
        return "/homeDecorAll";
      case "AIGIFTS-BANNERS":
        return "/aiPowerGifts";
      case "PLANPARTY-BANNERS":
        return "/events";
      case "EVENTMGR-BANNERS":
        return "/eventmanager";
      case "ESHAGUN-BANNERS":
        return "/eshagun";
      case "CORPORATEGIFTING-BANNERS":
        return "/corporateGifting";
      default:
        return "/";
    }
  };

  const carouselStyle = {
    transition: "all .5s",
    ml: `-${currentSlide * 100}%`,
  };
  const SLIDES_INTERVAL_TIME = 3000;
  const ANIMATION_DIRECTION = "right";
  useEffect(() => {
    const prevSlide = () => {
      setCurrentSlide((s) => (s === 0 ? slidesCount - 1 : s - 1));
    };

    const nextSlide = () => {
      setCurrentSlide((s) => (s === slidesCount - 1 ? 0 : s + 1));
    };

    const automatedSlide = setInterval(() => {
      ANIMATION_DIRECTION.toLowerCase() === "left" ? prevSlide() : nextSlide();
    }, SLIDES_INTERVAL_TIME);
    return () => clearInterval(automatedSlide);
  }, [slidesCount]);
  return (
    <Flex
      w="full"
      alignItems="center"
      justifyContent="center"
      mt={{ md: 18, base: 16 }}
    >
      <Flex w="full" overflow="hidden">
        <Flex pos="relative" w="full" {...carouselStyle}>
          {sortedBanner.map((slide, sid) => (
            <Box key={`slide-${sid}`} flex="none" boxSize="full" shadow="md">
              <Link to={getCategoryRoute(slide.categoryName)}>
                <Image
                  src={slide.imageUrl}
                  alt="carousel image"
                  boxSize="full"
                  backgroundSize="cover"
                  _hover={{ cursor: "pointer" }}
                />
              </Link>
            </Box>
          ))}
        </Flex>
      </Flex>
    </Flex>
  );
};

export default TopSlider;
